export default __webpack_public_path__ + "static/media/library-img.c1d2e9ed.svg";